export default __webpack_public_path__ + "static/media/fixture1_header.8d34ed15.png";